import React, { useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import notifications from "../../../../common/Components/Notifications/Notification";
import { useCashbookStatus } from "../../../../helpers/cashbookStatus";
import { useKT } from "../../i18n/kt";
import { kp } from "../../karkhanaPaths";
import PageHeader from "../../ui/PageHeader";
import CashbookGuard from "../CashbookGuard";
import SupervisorCashHome from "../supervisor/SupervisorCashHome";
import HandOverCash, { HandKind } from "./HandOverCash";
import "../cashbook.scss";
import "./owner.scss";

/**
 * /karkhana/money/cash-book/supervisor/:userId — one supervisor's day as the owner sees it: the same
 * नकद screen, read-only (earlier days with ?date=), plus what the owner records for him: cash handed
 * over (the float top-up), cash he gave back, and a spend typed from his spends page ("for a holder").
 * ?act=handover opens the hand-over form (the Pay page's "Hand over" and the Supervisors tab link here).
 */
const HolderDay = () => {
  const { t } = useKT();
  const { userId } = useParams<{ userId: string }>();
  const { search } = useLocation();
  const status = useCashbookStatus();
  const [form, setForm] = useState<HandKind | null>(() => (new URLSearchParams(search).get("act") === "handover" ? "HANDOVER" : null));
  const [rev, setRev] = useState(0);
  return (
    <CashbookGuard staffOnly>
      <div className="cb cbo-holder-head">
        <PageHeader title={t("Supervisor cash")} back={kp.cashBook({ tab: "supervisors" })} backLabel={t("Back")}>
          <button type="button" className="kh-btn is-primary" aria-expanded={form === "HANDOVER"} onClick={() => setForm(form === "HANDOVER" ? null : "HANDOVER")}>
            {t("Hand over cash")}
          </button>
          <button type="button" className="kh-btn" aria-expanded={form === "RETURN"} onClick={() => setForm(form === "RETURN" ? null : "RETURN")}>
            {t("Cash given back")}
          </button>
          <Link to={kp.cashSpend({ holder: userId })} className="kh-btn">
            {t("Type a spend for them")}
          </Link>
        </PageHeader>
        {form ? (
          <HandOverCash
            key={form}
            supervisorUserId={userId}
            kind={form}
            onCancel={() => setForm(null)}
            onDone={() => {
              notifications({ title: t("Saved"), message: t(form === "HANDOVER" ? "Cash handed over" : "Cash given back"), type: "success" });
              setForm(null);
              setRev((r) => r + 1);
              status.refresh();
            }}
          />
        ) : null}
      </div>
      <SupervisorCashHome key={rev} holderUserId={userId} readOnly />
    </CashbookGuard>
  );
};

export default HolderDay;
